/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import { useQuery } from '@panel/commons/hooks';
import { withSnackbar } from '@panel/commons/lib/snackbar';
import { FieldRow, PaymentContainer, PaymentRow, PaymentButton, TextWithLink } from '../../styles';
import PaypalCheckout from './fields/paypal';
import {
  createInactiveOrder,
  getEcommerceUser,
  getOrderData,
  getProductTaxes,
  selectCurrentProduct,
  selectProductTaxes,
  selectProductTaxesParams
} from '../../../../../ducks/step4Module2';
import { usePublisherRedirection } from '../../../../../hooks/usePublisherRedirection';

function PayPalForm() {
  const [enablePayment, setEnablePayment] = useState(false);
  const { userId, productId } = useSelector(selectProductTaxesParams);
  const paymentInfo = useSelector(selectProductTaxes);
  const order = useSelector(getOrderData);
  const currentProduct = useSelector(selectCurrentProduct);
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  usePublisherRedirection(!productId, '/planes/seleccion');

  useEffect(() => {
    if (productId) {
      dispatch(getEcommerceUser());
    }
  }, [productId, dispatch]);

  useEffect(() => {
    if (productId && currentProduct && currentProduct.id && currentProduct.priceList) {
      const productIds = [currentProduct.id];
      dispatch(createInactiveOrder({ userType: currentProduct.priceList, productIds, postingId }));
    }
  }, [currentProduct, dispatch, postingId, productId]);

  useEffect(() => {
    if (productId && currentProduct && currentProduct.priceList && userId) {
      dispatch(getProductTaxes(userId, { products: productId, userType: currentProduct.priceList, postingId }));
    }
  }, [dispatch, productId, userId, currentProduct, postingId]);

  useEffect(() => {
    if (order && order.orderId) {
      setEnablePayment(true);
    }
  }, [order]);

  const handleClick = () => {
    if (enablePayment) {
      history.push(`/publicador/planes/pago/transferencia?postingId=${postingId}`);
    }
  };

  return (
    <PaymentContainer data-repa='step4Module2-payPalForm-container'>
      <form id='step4Module2PayPalForm'>
        <PaymentRow data-repa='step4Module2-payPalForm-paymentMethod-payPal-row' key='payPal'>
          <PaypalCheckout order={order} product={currentProduct} paymentInfo={paymentInfo} enabled={enablePayment} />
        </PaymentRow>
        <PaymentRow
          data-repa='step4Module2-payPalForm-paymentMethod-wireTransfer-row'
          className='wireTransfer'
          key='wireTransfer'
        >
          <PaymentButton
            as='button'
            data-repa='step4Module2-payPalForm-paymentMethod-wireTransfer-button'
            key='paymentButton-wireTransfer'
            disabled={!paymentInfo.taxes || !enablePayment}
            onClick={handleClick}
          >
            <span data-repa='step4Module2-payPalForm-paymentMethod-wireTransfer-button-span'>
              {t('publisher.step4.module2.button.wireTransfer')}
            </span>
          </PaymentButton>
        </PaymentRow>
        <FieldRow>
          <TextWithLink>
            <a target='_blank' rel='noopener noreferrer' href={t('publisher.step4.module2.payment.terms.use.href')}>
              {t('publisher.step4.module2.terms.use')}
            </a>
            {t('publisher.step4.module2.terms.separator')}
            <a target='_blank' rel='noopener noreferrer' href={t('publisher.step4.module2.terms.hiring.href')}>
              {t('publisher.step4.module2.terms.hiring')}
            </a>
          </TextWithLink>
        </FieldRow>
      </form>
    </PaymentContainer>
  );
}

export default withSnackbar({ fixed: 'true' })(PayPalForm);
